import React from 'react';
import styled from 'styled-components';
import { GRID } from '../../../../lib/constants';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';

const GridDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 100%;
  margin-left: -10px;
  justify-content: center;
`;

const GridMobileDiv = styled(GridDiv)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 0;
`;

const GridInDropdownDiv = styled(GridDiv)`
  overflow: hidden;
  ${p => (p.height ? `height: ${p.height}px;` : '')}
`;

const Gutter = styled.div`
  margin: ${p => p.theme.unit(p.gutterTB)} ${p => p.theme.unit(p.gutterRL)};
`;

const emptyCallback = () => {};

const Grid = (props) => {
  // TODO: Titles for each grid occur on the wrapper.
  const 
  {
    styleMobile,
    styleDesktop,
    Comp,
    items,
    locale,
    removeItemHandler = emptyCallback,
    saveItemHandler = emptyCallback,
    pageStateModifiers = {},
    itemSize = GRID,
    hideWrappedItems = false, // when true, hide items that are wrapped to the second row
    height, // height value is required for hiding wrapped items
    gutterTB = 1.5,
    gutterRL = 1.125,
  } = props;
  const DefaultGridDesktop = ({ children }) => (
    <GridDiv style={styleDesktop}>
      { children }
    </GridDiv>
  );

  const DefaultGridMobile = ({ children }) => (
    <GridMobileDiv style={styleMobile}>
      { children }
    </GridMobileDiv>
  );

  const DefaultGrid = ({ children }) => (
    <MediaQueryHelper
      desktopChildren={(<DefaultGridDesktop>{children}</DefaultGridDesktop>)}
      mobileChildren={(<DefaultGridMobile>{children}</DefaultGridMobile>)} />);

  const GridToUse = hideWrappedItems ? GridInDropdownDiv : DefaultGrid;

  return (
    <GridToUse height={height}>
      { items && items.length >= 1 && items.map((item, index) => {
        const layoutKey = `grid-item-${index}-${item.id}`;

        return (
          <Gutter key={layoutKey} gutterTB={gutterTB} gutterRL={gutterRL}>
            {/* Comp is OfferCard or ShopCard */}
            <Comp
              viewType={itemSize}
              {...item}
              removeItemHandler={removeItemHandler}
              saveItemHandler={saveItemHandler}
              pageStateModifiers={pageStateModifiers}
              locale={locale} />
          </Gutter>);
      })
      }
    </GridToUse>
  );
};

export default Grid;
